import { createAsyncThunk } from '@reduxjs/toolkit';
import apiCall from 'utils/api';
import { OrgProfile, OrgProfileUpdatePayload } from './types';

export const fetchProfile = createAsyncThunk(
  'orgProfile/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ data: OrgProfile }>('get', '/api/organization/profile/');
      return response.data.data;
    } catch (error: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch profile data');
    }
  }
);

export const updateProfile = createAsyncThunk(
  'orgProfile/updateProfile',
  async (profileData: OrgProfileUpdatePayload, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ message: string }>('put', '/api/organization/profile/update/', profileData);
      return response.data.message;
    } catch (error: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
      return rejectWithValue(error.response?.data?.message || 'Failed to update profile data');
    }
  }
);
